"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _configuratorCarousel = require("@mmc/configurator-carousel");
var _modelFilter = require("@mmc/model-filter");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var _actions = require("../actions");
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  isEmptyObject = dataUtils.isEmptyObject;
var allPreferences = [{
  label: 'fuelType',
  updateEvent: _actions.setFuelType
}, {
  label: 'transmissionType',
  updateEvent: _actions.setTransmissionType
}, {
  label: 'drivetrain',
  updateEvent: _actions.setDriveType
}];
var PreferencesSelector = /*#__PURE__*/function (_React$Component) {
  function PreferencesSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.changeEvent = _this.changeEvent.bind(_this);
    _this.clearAll = _this.clearAll.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(PreferencesSelector, _React$Component);
  var _proto = PreferencesSelector.prototype;
  _proto.handleKeyUp = function handleKeyUp(e) {
    var clearKeys = [{
      type: 'backspace',
      code: 27
    }, {
      type: 'esc',
      code: 8
    }, {
      type: 'delete',
      code: 46
    }];
    for (var i = 0; i < clearKeys.length; i += 1) {
      if (e.which === clearKeys[i].code) {
        this.clearAll();
        break;
      }
    }
  };
  _proto.getEnabledOptions = function getEnabledOptions() {
    var _this$props = this.props,
      fuelType = _this$props.fuelType,
      transmissionType = _this$props.transmissionType,
      driveType = _this$props.driveType,
      data = _this$props.data;
    var models = data.models || [];
    var currentSelections = {
      fuelType: fuelType,
      transmissionType: transmissionType,
      drivetrain: driveType
    };
    var allOptions = {};
    var simpleEnabled = {};
    var refinedEnabledOptions = {};
    var enabledOptions = [{}, {}, {}];
    if (!isEmptyArray(models)) {
      models.forEach(function (model) {
        // Gather all available options
        allPreferences.forEach(function (preference) {
          if (allOptions[preference.label] === undefined) {
            allOptions[preference.label] = [];
            simpleEnabled[preference.label] = [];
            refinedEnabledOptions[preference.label] = [];
            for (var i = 0; i < allPreferences.length; i += 1) {
              enabledOptions[i][preference.label] = [];
            }
          }
          if (!allOptions[preference.label].includes(model[preference.label])) {
            allOptions[preference.label].push(model[preference.label]);
          }
        });
      });

      // Gather which options are avilable for each stage and selected option
      allPreferences.forEach(function (preference, i) {
        var enabledAtPref = {};
        models.forEach(function (model) {
          if (currentSelections[preference.label] !== '' && currentSelections[preference.label] !== undefined) {
            if (currentSelections[preference.label] === model[preference.label]) {
              allPreferences.forEach(function (childPreference) {
                if (childPreference.label !== preference.label) {
                  if (enabledAtPref[childPreference.label] === undefined) {
                    enabledAtPref[childPreference.label] = [];
                  }
                  enabledAtPref[childPreference.label].push(model[childPreference.label]);
                } else {
                  enabledAtPref[childPreference.label] = allOptions[childPreference.label];
                }
              });
            }
          } else {
            allPreferences.forEach(function (childPreference) {
              enabledAtPref[childPreference.label] = allOptions[childPreference.label];
            });
          }
        });
        enabledOptions[i] = enabledAtPref;
      });

      // Rearrange options into a useful format
      allPreferences.forEach(function (preference) {
        enabledOptions.forEach(function (optionGroup, i) {
          allPreferences.forEach(function (childPreference) {
            if (preference === childPreference) {
              simpleEnabled[preference.label].push(enabledOptions[i][childPreference.label]);
            }
          });
        });
      });

      // Gather options that are avilable across the different option arrays
      allPreferences.forEach(function (preference) {
        allOptions[preference.label].forEach(function (option) {
          var matchedInAll = true;
          simpleEnabled[preference.label].forEach(function (prefGroup) {
            if (!prefGroup || !prefGroup.includes(option)) {
              matchedInAll = false;
            }
          });
          if (matchedInAll) {
            refinedEnabledOptions[preference.label].push(option);
          }
        });
      });
    }
    return refinedEnabledOptions;
  };
  _proto.changeEvent = function changeEvent(e, optionKey) {
    var dispatch = this.props.dispatch;
    var currentPreference = null;
    if (optionKey !== undefined && optionKey !== '') {
      currentPreference = allPreferences.find(function (preference) {
        return preference.label === optionKey;
      });
    } else {
      var fieldName = e.target.name.toLowerCase();
      currentPreference = allPreferences.find(function (preference) {
        return preference.label.toLowerCase().includes(fieldName.toLowerCase().replace(/ +/g, ''));
      });
    }
    dispatch(currentPreference.updateEvent(e.target.value));
  };
  _proto.clearAll = function clearAll() {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.clearAllPreferences)());
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      fuelType = _this$props2.fuelType,
      transmissionType = _this$props2.transmissionType,
      driveType = _this$props2.driveType,
      _this$props2$theme = _this$props2.theme,
      theme = _this$props2$theme === void 0 ? {} : _this$props2$theme,
      data = _this$props2.data;
    var filterSection = data.filterSection || {};
    var carousel = data.carousel || {};
    var headingText = data.headingText;
    var direction = this.props.direction;
    var enabledOptions = this.getEnabledOptions();
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _configurator["default"].stepContent + " " + (isEmptyObject(carousel) && isEmptyObject(filterSection) ? _configurator["default"].reserveHeight : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, !isEmptyArray(carousel.items) && !isEmptyObject(carousel) && /*#__PURE__*/_react["default"].createElement(_configuratorCarousel.ConfiguratorCarousel, {
      theme: theme,
      data: carousel
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme.marginBottom80,
      onKeyUp: this.handleKeyUp,
      dir: direction,
      role: "button",
      tabIndex: 0
    }, !isEmptyObject(filterSection) && /*#__PURE__*/_react["default"].createElement(_modelFilter.ModelFilter, {
      theme: theme,
      data: filterSection,
      headingText: headingText,
      changeEvent: this.changeEvent,
      selectedOptions: [fuelType, transmissionType, driveType],
      enabledOptions: enabledOptions,
      clearAll: this.clearAll
    }), data.disclaimer && /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.smallType + " " + _configurator["default"].stepDisclaimer + " " + _configurator["default"].padded
    }, data.disclaimer))));
  };
  return PreferencesSelector;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    fuelType: state.fuelType.value,
    driveType: state.driveType.value,
    transmissionType: state.transmissionType.value,
    theme: props.theme,
    data: props.data
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(PreferencesSelector);